import { Component, OnInit } from '@angular/core';

interface ItemData2 {
  name: string;
  age: string;
  address: string;
}

@Component({
  selector: 'app-device-master',
  templateUrl: './device-master.component.html',
  styleUrls: ['./device-master.component.scss']
})
export class DeviceMasterComponent implements OnInit {
  listOfData2: ItemData2[] = [];
  selectedValue = null;
  value?: string;

  constructor() { }

  ngOnInit(): void {

    for (let i = 0; i < 100; i++) {
      this.listOfData2.push({
        name: `${i}`,
        age: 'Kalubhai',
        address: 'General'
      });
    }
  }

}
